export function createPermissionTracker({ onStateChange } = {}) {
  const subscriptions = { camera: null, microphone: null };

  async function refresh() {
    if (typeof navigator === "undefined" || !navigator.permissions?.query) {
      return;
    }

    const targets = ["camera", "microphone"];
    for (const name of targets) {
      try {
        const status = await navigator.permissions.query({ name });
        if (subscriptions[name] && subscriptions[name] !== status) {
          subscriptions[name].onchange = null;
        }
        status.onchange = () => {
          onStateChange?.(name, status.state || "unknown");
        };
        subscriptions[name] = status;
        onStateChange?.(name, status.state || "unknown");
      } catch (error) {
        // ignore browsers without support
      }
    }
  }

  function dispose() {
    Object.values(subscriptions).forEach(status => {
      if (status) {
        status.onchange = null;
      }
    });
  }

  return { refresh, dispose };
}

export function inferDeniedDevicesFromError(error) {
  if (!errorImpliesPermissionIssue(error)) {
    return [];
  }
  const message = (error?.message || "").toLowerCase();
  const denied = [];
  if (message.includes("camera")) {
    denied.push("camera");
  }
  if (message.includes("microphone") || message.includes("audio")) {
    denied.push("microphone");
  }
  if (!denied.length) {
    denied.push("microphone", "camera");
  }
  return denied;
}

export function errorImpliesPermissionIssue(error) {
  if (!error) {
    return false;
  }
  const message = error.message || String(error);
  return /notallowederror/i.test(message) || /denied/i.test(message) || /permission/i.test(message);
}
